import { sendRawRequest } from "~/api/clients/axios";
import { AxiosHttpError } from "~/types/common/error.types";
import { SendForgotPasswordCodeInput } from "~/types/input/auth.types";

interface SendForgotPasswordCodeResponse {
  CodeDeliveryDetails: CodeDeliveryDetails;
}

interface CodeDeliveryDetails {
  Destination: string;
  DeliveryMedium: string;
  AttributeName: string;
}

export default async function sendForgotPasswordCode(
  input: SendForgotPasswordCodeInput
) {
  try {
    const res = await sendRawRequest<
      SendForgotPasswordCodeInput,
      SendForgotPasswordCodeResponse
    >("post", "/auth/forgot-password", input);
    const {
      data: { CodeDeliveryDetails },
    } = res;

    if (!!CodeDeliveryDetails) return { success: true, data: res.data };
  } catch (err) {
    const axiosError = err as AxiosHttpError;
    if (axiosError.response?.data) {
      const { message } = axiosError.response.data;
      return {
        success: false,
        action: typeof message === "string" ? message : message[0],
      };
    }
  }
  return {
    success: false,
    action: "Unkown Error",
  };
}
